import { render, staticRenderFns } from "./Formatter.vue?vue&type=template&id=a28f799c&"
import script from "./Formatter.vue?vue&type=script&lang=ts&"
export * from "./Formatter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports